<template>
  <v-card
    width="100%"
    :dark="value"
    :class="classes"
    :color="color"
    :height="height"
    :style="styleAttrs"
  >
    <v-checkbox
      class="checkbox"
      :on-icon="onIcon"
      :off-icon="offIcon"
      :input-value="value"
      @change="$emit('change', $event)"
    />
    <div class="content">
      <div :class="{label: true, outlined: !value}">{{ label }}</div>
      <div v-if="description" :class="{description: true, outlined: !value}">
        {{ description }}
      </div>
    </div>
  </v-card>
</template>

<script>
/**
 * @private
 */
export default {
  props: {
    label: {
      type: String,
    },

    styleAttrs: {
      type: Object,
      default: () => ({}),
    },

    description: {
      type: String,
    },

    value: {
      type: Boolean,
      default: false,
    },

    height: {
      type: [Number, String],
      default: 60,
    },

    onIcon: {
      type: String,
      default: '$check_box_rounded',
    },

    offIcon: {
      type: String,
      default: '$check_box_outline_blank_rounded',
    },
  },

  computed: {
    iconColor() {
      return this.value ? 'white' : 'primary'
    },
    color() {
      return this.value ? 'primary' : 'white'
    },
    classes() {
      return {
        'zoox-group-select': true,
        outlined: !this.value,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'style';

.zoox-group-select {
  @extend %zoox-group-select;

  grid-template-columns: 45px auto 30px;
}
</style>
